export const isInvalidTokenError = (error) => {
  const code = String(error?.code || error?.response?.data?.code || '').toLowerCase();
  const message = String(error?.message || error?.response?.data?.message || '').toLocaleLowerCase('tr-TR');

  return (
    code === 'auth_failed' ||
    message.includes('geçersiz token') ||
    message.includes('token süresi doldu') ||
    message.includes('oturum süresi doldu')
  );
};

export const redirectToLoginForInvalidSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('username');

  if (window.location.pathname !== '/login') {
    window.location.assign('/login');
  }
};
